import IntlMessages from '@nxsys/helpers/IntlMessages';
import Icon from '@nxsys/components/AppIconImage';
import { IconMessages } from '@nxsys/assets/icons';
import { useSelector } from 'react-redux';
import type { AppState } from '@nxsys/store';
import { Badge } from 'antd';

import {
  DropDownWrapper,
  StyledHeaderMsgIcon,
  StyledHeaderMsgLink,
  StyledHeaderMsgLinkText,
} from './index.styled';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';

const AppHeaderMessages = () => {
  const navigate = useNavigateWithQuery();
  const totalUnread = useSelector(
    (state: AppState) => state.messageStore?.totalUnread ?? 0,
  );

  return (
    <DropDownWrapper>
      <StyledHeaderMsgLink onClick={() => navigate('/messages')}>
        <StyledHeaderMsgIcon className={totalUnread > 0 ? 'header-icon-has-unread' : ''}>
          <Badge count={totalUnread} overflowCount={99} size="small">
            <Icon src={IconMessages} alt="Messages" />
          </Badge>
        </StyledHeaderMsgIcon>
        <StyledHeaderMsgLinkText>
          <IntlMessages id="dashboard.messages" />
        </StyledHeaderMsgLinkText>
      </StyledHeaderMsgLink>
    </DropDownWrapper>
  );
};

export default AppHeaderMessages;
